import { mapKeys, snakeCase } from "lodash";
import { formatCurrencyAsFloat } from "Utils/Formatters";

const parseAge = (age) => (age !== undefined && age !== null ? parseInt(age, 10) : null);

export const formatEmployeeProfileAsInitialValues = (employeeProfile) =>
  employeeProfile.map((employee) => {
    const dependents = [];

    if (employee.spouse_age || employee.spouse_age === null) {
      dependents.push({
        type: "Spouse",
        age: employee.spouse_age,
      });
    }

    if (employee.children && employee.children.length > 0) {
      employee.children.forEach((childAge, i) =>
        dependents.push({
          type: "Child",
          age: childAge,
          childIndex: i,
        }),
      );
    }

    const formattedEmployee = {
      name: employee.name,
      age: employee.age,
      dependents,
      ...(employee.zip_code
        ? {
            zip_code: employee.zip_code,
          }
        : {}),
      ...(employee.gender
        ? {
            gender: employee.gender,
          }
        : {}),
      ...(employee.zipCode
        ? {
            zip_code: employee.zipCode,
          }
        : {}),
      ...(employee.salary
        ? {
            salary: formatCurrencyAsFloat(employee.salary),
          }
        : {}),
      ...(employee.age ? {} : { autoFocus: true }),
      ...(employee.id ? { id: employee.id } : {}),
    };

    if (employee.full_time !== undefined) {
      formattedEmployee.full_time = employee.full_time;
    }

    if (employee.full_time === undefined) {
      formattedEmployee.full_time = true;
    }

    return formattedEmployee;
  });
export const formatFormValuesAsEmployeeProfile = (values) => {
  if (!values) {
    return [];
  }

  const convertKeysToSnakeCase = (values) => values.map((obj) => mapKeys(obj, (_, key) => snakeCase(key)));

  const employeeProfile = convertKeysToSnakeCase(values);
  const newEmployeeProfile = employeeProfile.map((employee) => {
    const children = [];
    let spouseAge;
    (employee.dependents || []).forEach((dep) => {
      if (dep.type === "Child") {
        let age = parseAge(dep.age);

        if (isNaN(age)) {
          age = null;
        }

        children.push(age);
      } else if (dep.type === "Spouse") {
        spouseAge = parseAge(dep.age);

        if (isNaN(spouseAge)) {
          spouseAge = null;
        }
      }
    });
    let age = parseAge(employee.age);

    if (isNaN(age)) {
      age = null;
    }

    const formattedEmployee = {
      name: employee.name,
      age,
      children,
      ...(employee.zip_code
        ? {
            zip_code: employee.zip_code,
          }
        : {}),
      ...(employee.gender
        ? {
            gender: employee.gender,
          }
        : {}),
      ...(employee.zipCode
        ? {
            zip_code: employee.zipCode,
          }
        : {}),
      ...(employee.salary
        ? {
            salary: formatCurrencyAsFloat(employee.salary),
          }
        : {}),
      ...(employee.age ? {} : { autoFocus: true }),
      ...(employee.id ? { id: employee.id } : {}),
    };

    if (spouseAge !== undefined) {
      formattedEmployee.spouse_age = spouseAge;
    }

    if (employee.full_time !== undefined) {
      formattedEmployee.full_time = employee.full_time;
    }

    if (employee.full_time === undefined) {
      formattedEmployee.full_time = true;
    }

    return formattedEmployee;
  });
  return newEmployeeProfile;
};
